// src/scripts/fluco-lib/events.js
var EVENTS = {
  SHOPIFY_BLOCK_SELECT: "shopify:block:select",
  SHOPIFY_BLOCK_DESELECT: "shopify:block:deselect",
  SHOPIFY_SECTION_DESELECT: "shopify:section:deselect",
  SHOPIFY_SECTION_SELECT: "shopify:section:select",
  SHOPIFY_SECTION_LOAD: "shopify:section:load",
  SHOPIFY_SECTION_UNLOAD: "shopify:section:unload",
  SWIPER_JS_LOADED: "fluco_section:swiper_js_loaded",
  COUNTDOWN_TIMER_COMPLETED_EVENT: "fluco_section:countdown_timer_completed"
};
var events_default = EVENTS;

// src/scripts/fluco-lib/load-swiper.js
var { SWIPER_JS_LOADED } = events_default;
function loadSwiper(functionName, passedThis) {
  if (window.Swiper) {
    passedThis[functionName]();
  } else {
    window.addEventListener(SWIPER_JS_LOADED, () => {
      passedThis[functionName]();
    });
  }
}

// src/scripts/fluco-lib/media-queries.js
function getMediaQuery(querySize, sectionElement) {
  const value = getComputedStyle(sectionElement).getPropertyValue(
    `--fluco-js-${querySize}`
  );
  if (!value) {
    console.warn("Invalid querySize passed to getMediaQuery");
    return false;
  }
  return value;
}
function checkMediaQuery(querySize, sectionElement) {
  const mediaQuery = getMediaQuery(querySize, sectionElement);
  return window.matchMedia(mediaQuery).matches;
}

// src/scripts/fluco-lib/activate-template.js
var activateTemplate = (key, { resolveOnMissing = false, parentEl = document } = {}) => {
  const templateElement = parentEl.querySelector(
    `template[data-template-key='${key}']`
  );
  if (!templateElement) {
    if (resolveOnMissing) {
      console.warn(
        "Template not found, resolving because of 'resolveOnMissing option"
      );
      return Promise.resolve({ wasInjected: false });
    }
    return Promise.reject(new Error("Template not found"));
  }
  if (templateElement.hasAttribute("data-has-been-activated")) {
    return Promise.resolve({ wasInjected: false });
  }
  const promise = new Promise((resolve) => {
    const doKludgeForOldSafari = navigator.userAgent.includes("Safari") && navigator.userAgent.includes("Version/15");
    const templateClone = templateElement.content.cloneNode(true);
    let images;
    if (doKludgeForOldSafari) {
      images = templateClone.querySelectorAll("img[srcset]");
    }
    templateElement.after(templateClone);
    if (doKludgeForOldSafari) {
      images.forEach((image) => {
        image.outerHTML = image.outerHTML;
      });
    }
    templateElement.setAttribute("data-has-been-activated", true);
    resolve({ wasInjected: true });
  });
  return promise;
};

// src/scripts/sections/statistics-1.js
var Statistics1 = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      contentArea: ".fluco-content-area",
      mobileCarouselTemplate: "[js-mobile-carousel-template]",
      mobileCarouselTemplateKeyAndValue: "template[data-template-key='statistics-mobile-carousel']",
      mobileCarouselTemplateKeyValue: "statistics-mobile-carousel",
      // Template key, not a class
      mobileSwiper: "[js-swiper]",
      mobileSwiperPagination: "[js-swiper-pagination]",
      statisticBlockNumber: "[js-statistic-block-number]",
      statisticNumberEl: "[js-statistic-number]"
    };
    this.attrs = {
      statisticNumberValue: "data-statistic-number-value",
      thousandsSeparatorType: "data-number-statistic-thousands-separator-type",
      countingAnimationEnabled: "data-counting-animation-enabled",
      animationDuration: "data-animation-duration",
      animationSpeed: "data-animation-speed",
      animationStaggerDirection: "data-animation-stagger-direction",
      animationStaggerDelay: "data-animation-stagger-delay",
      statisticEndValue: "data-statistic-end-value",
      statisticStartValue: "data-statistic-start-value",
      decimalPlaces: "data-decimal-places",
      mobileLayout: "data-mobile-layout",
      hasBeenActivated: "data-has-been-activated"
    };
  }
  connectedCallback() {
    this.eventController = new AbortController();
    this.eventOptions = { signal: this.eventController.signal };
    this.contentArea = this.querySelector(this.selectors.contentArea);
    this.countingAnimationEnabled = this.contentArea.getAttribute(this.attrs.countingAnimationEnabled) === "true";
    this.mobileCarouselEnabled = this.contentArea.getAttribute(this.attrs.mobileLayout) === "carousel";
    this.hasNumberBlocks = this.querySelectorAll(this.selectors.statisticBlockNumber).length > 0;
    if (this.hasNumberBlocks) {
      this.numberBlocks = this.querySelectorAll(
        this.selectors.statisticBlockNumber
      );
      this.initNumberBlocks(this.numberBlocks);
      if (this.countingAnimationEnabled) {
        this.setupGridObserver(this.numberBlocks);
      }
    }
    if (this.mobileCarouselEnabled) {
      this.mobileCarouselTemplate = this.querySelector(
        this.selectors.mobileCarouselTemplate
      );
      window.addEventListener("resize", this.handleResize.bind(this), {
        passive: true,
        signal: this.eventController.signal
      });
      const isMobile = checkMediaQuery("mobile", this.contentArea);
      if (this.mobileCarouselTemplate && isMobile) {
        this.initMobileCarousel().catch(console.error);
      }
    }
  }
  initNumberBlocks(numberBlocks) {
    this.thousandsSeparatorType = this.contentArea.getAttribute(
      this.attrs.thousandsSeparatorType
    );
    numberBlocks.forEach((block) => {
      const statisticNumberEl = block.querySelector(
        this.selectors.statisticNumberEl
      );
      if (!statisticNumberEl) return;
      const statisticNumberValue = statisticNumberEl.getAttribute(
        this.attrs.statisticNumberValue
      );
      const statisticEndValue = parseFloat(statisticNumberValue);
      const decimalPlaces = statisticNumberValue.includes(".") ? statisticNumberValue.split(".")[1]?.length || 0 : 0;
      const finalFormattedNumber = this.formatNumberWithSeparator(
        statisticEndValue,
        decimalPlaces
      );
      if (this.countingAnimationEnabled) {
        const statisticNumberDigitCount = statisticNumberValue.split(".")[0].length;
        const statisticStartValue = statisticNumberDigitCount >= 3 ? Math.pow(10, statisticNumberDigitCount - 2) : 0;
        statisticNumberEl.setAttribute(
          this.attrs.statisticStartValue,
          statisticStartValue
        );
        statisticNumberEl.setAttribute(
          this.attrs.statisticEndValue,
          statisticEndValue
        );
        statisticNumberEl.setAttribute(this.attrs.decimalPlaces, decimalPlaces);
        const numberContentEl = statisticNumberEl.parentElement;
        if (numberContentEl) {
          const originalNumberContent = statisticNumberEl.textContent;
          statisticNumberEl.textContent = finalFormattedNumber;
          const finalHeight = numberContentEl.offsetHeight;
          block.style.setProperty(
            "--statistic-final-height",
            `${finalHeight}px`
          );
          statisticNumberEl.textContent = originalNumberContent;
        }
      } else {
        statisticNumberEl.textContent = finalFormattedNumber;
      }
    });
  }
  setupGridObserver(numberBlocks) {
    this.gridObserver?.disconnect();
    this.gridObserver = this.createObserver(numberBlocks, "grid");
  }
  setupCarouselObserver(numberBlocks) {
    this.carouselObserver?.disconnect();
    this.carouselObserver = this.createObserver(numberBlocks, "carousel");
  }
  createObserver(numberBlocks, layoutType) {
    this.animationDuration = parseInt(
      this.contentArea.getAttribute(this.attrs.animationDuration)
    );
    this.animationSpeed = parseInt(
      this.contentArea.getAttribute(this.attrs.animationSpeed)
    );
    this.animationStaggerDirection = this.contentArea.getAttribute(
      this.attrs.animationStaggerDirection
    );
    if (this.animationStaggerDirection !== "none") {
      if (layoutType === "carousel") {
        this.animationStaggerDirection = "none";
      }
      this.animationStaggerDelay = parseInt(
        this.contentArea.getAttribute(this.attrs.animationStaggerDelay)
      );
    }
    const threshold = layoutType === "carousel" ? 0.4 : 0.15;
    const blocksArray = Array.from(numberBlocks);
    const orderedBlocks = this.animationStaggerDirection === "right" ? blocksArray.reverse() : blocksArray;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const blockIndex = orderedBlocks.indexOf(entry.target);
            const staggerDelay = this.animationStaggerDirection === "none" ? 0 : blockIndex * this.animationStaggerDelay;
            setTimeout(() => {
              this.animateStatisticNumbers(entry.target);
            }, staggerDelay);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold
      }
    );
    orderedBlocks.forEach((block) => {
      observer.observe(block);
    });
    return observer;
  }
  resetTemplateActivation() {
    const templateElement = this.contentArea.querySelector(
      this.selectors.mobileCarouselTemplateKeyAndValue
    );
    templateElement?.removeAttribute(this.attrs.hasBeenActivated);
  }
  cleanupMobileCarousel() {
    this.swiperInstance?.destroy();
    this.swiperInstance = null;
    this.carouselObserver?.disconnect();
    this.carouselObserver = null;
    this.swiperMobileContainer?.remove();
    this.swiperMobileContainer = null;
    this.resetTemplateActivation();
  }
  handleResize() {
    const isMobile = checkMediaQuery("mobile", this.contentArea);
    if (isMobile && !this.swiperInstance) {
      this.initMobileCarousel().catch(console.error);
    } else if (!isMobile && this.swiperInstance) {
      this.cleanupMobileCarousel();
    }
  }
  async initMobileCarousel() {
    if (this.swiperInstance) return;
    await activateTemplate(this.selectors.mobileCarouselTemplateKeyValue, {
      parentEl: this.contentArea
    });
    this.swiperMobileContainer = this.querySelector(this.selectors.mobileSwiper);
    if (!this.swiperMobileContainer) {
      console.warn("Failed to initialize mobile carousel container");
      return;
    }
    loadSwiper("setupSwiper", this);
    if (this.hasNumberBlocks) {
      const carouselNumberBlocks = this.querySelectorAll(
        `${this.selectors.mobileSwiper} ${this.selectors.statisticBlockNumber}`
      );
      this.initNumberBlocks(carouselNumberBlocks);
      if (this.countingAnimationEnabled) {
        this.setupCarouselObserver(carouselNumberBlocks);
      }
    }
  }
  setupSwiper() {
    this.swiperMobileContainer = this.querySelector(this.selectors.mobileSwiper);
    this.mobileSwiperPagination = this.swiperMobileContainer.querySelector(
      this.selectors.mobileSwiperPagination
    );
    this.swiperInstance = new window.Swiper(this.swiperMobileContainer, {
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: this.mobileSwiperPagination
      }
    });
  }
  formatNumberWithSeparator(value, decimalPlaces) {
    const fixedValue = Number(value).toFixed(decimalPlaces);
    const [integerRaw, decimalPart = ""] = fixedValue.split(".");
    const useSeparator = this.thousandsSeparatorType !== "none";
    const separator = this.thousandsSeparatorType === "comma" ? "," : " ";
    const integerPart = useSeparator && integerRaw.length >= 4 ? integerRaw.replace(/\B(?=(\d{3})+(?!\d))/g, separator) : integerRaw;
    return decimalPlaces > 0 ? `${integerPart}.${decimalPart}` : integerPart;
  }
  animateStatisticNumbers(numberStatisticsBlock) {
    const statisticNumberEl = numberStatisticsBlock.querySelector(
      this.selectors.statisticNumberEl
    );
    if (!statisticNumberEl) return;
    const statisticStartValue = Number(
      statisticNumberEl.getAttribute(this.attrs.statisticStartValue)
    );
    const statisticEndValue = Number(
      statisticNumberEl.getAttribute(this.attrs.statisticEndValue)
    );
    const decimalPlaces = Number(
      statisticNumberEl.getAttribute(this.attrs.decimalPlaces)
    );
    const valueRange = statisticEndValue - statisticStartValue;
    const minInterval = this.animationDuration / Math.pow(this.animationSpeed, 1.5);
    const startTime = performance.now();
    let lastUpdateTime = startTime;
    const animate = () => {
      const now = performance.now();
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / this.animationDuration, 1);
      const timeSinceLastUpdate = now - lastUpdateTime;
      if (timeSinceLastUpdate >= minInterval || progress >= 1) {
        const currentValue = statisticStartValue + valueRange * progress;
        statisticNumberEl.textContent = this.formatNumberWithSeparator(
          currentValue,
          decimalPlaces
        );
        lastUpdateTime = now;
      }
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    animate();
  }
  disconnectedCallback() {
    this.eventController.abort();
    this.cleanupMobileCarousel();
    this.gridObserver?.disconnect();
    this.gridObserver = null;
  }
};
if (!customElements.get("fluco-local-v1-statistics-1")) {
  customElements.define("fluco-local-v1-statistics-1", Statistics1);
}
